/** MY ONE home widgets: Continuity gaps + Security indicator (authorised only). */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { LifeBuoy, ShieldCheck } from "lucide-react";

export function HomeSignalWidgets() {
  const [cont, setCont] = useState(null);
  const [sec, setSec] = useState(null);
  useEffect(() => {
    Promise.allSettled([
      api.get("/continuity/actions"),
      api.get("/public-ref/exceptions"),
    ]).then(([c, p]) => {
      const contItems = c.status === "fulfilled" ? (c.value.data.items || []) : [];
      const pubItems = p.status === "fulfilled" ? (p.value.data.items || []) : [];
      setCont([...pubItems, ...contItems]);
    });
    api.get("/security-centre/my-indicator").then(({ data }) => setSec(data.items || [])).catch(() => {});
  }, []);
  if (!cont && !sec) return null;
  return (
    <div className="grid md:grid-cols-2 gap-3 mb-3" data-testid="home-signal-widgets">
      {cont && (
        <div data-testid="home-continuity-widget"
            className="border border-emerald-200 bg-emerald-50/50 rounded-xl p-3 hover:border-emerald-500 transition-colors">
          <Link to="/continuity" className="flex items-center gap-1.5 text-[11px] font-semibold text-emerald-950">
            <LifeBuoy className="h-3.5 w-3.5" /> CONTINUITY &amp; EXCEPTIONS
            <span className="ml-auto text-[10px] font-mono">{cont.length} item(s)</span></Link>
          <div className="mt-1 space-y-0.5">
            {cont.slice(0, 4).map((a, i) => (
              <Link key={i} to={a.path || "/continuity"}
                className="block text-[10.5px] text-slate-600 truncate hover:text-emerald-800">• {a.label}</Link>))}
            {cont.length === 0 && <div className="text-[10.5px] text-emerald-700">Nothing needs attention.</div>}
          </div>
        </div>)}
      {sec && (
        <Link to="/admin/security-centre" data-testid="home-security-widget"
            className="border border-rose-200 bg-rose-50/40 rounded-xl p-3 hover:border-rose-500 transition-colors">
          <div className="flex items-center gap-1.5 text-[11px] font-semibold text-slate-950">
            <ShieldCheck className="h-3.5 w-3.5 text-rose-600" /> SECURITY</div>
          <div className="mt-1 grid grid-cols-2 gap-x-3 gap-y-0.5">
            {sec.map((m) => (
              <div key={m.key} className="text-[10.5px] text-slate-600 flex justify-between">
                <span>{m.label}</span><b className="font-mono">{m.value}</b></div>))}
          </div>
        </Link>)}
    </div>
  );
}
